import ReactDOM from 'react-dom';
import { initializeI18n } from '../localization/i18n';
import HeaderAi from '../components/aiTutor/common/HeaderAi';

// Expose render function globally
window.renderHeaderAi = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<HeaderAi props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering Header:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};
